export enum ChargebackStatus {
    Pending = "PENDING",
    InProgress = "IN_PROGRESS",
    Refunded = "REFUNDED",
    Rejected = "REJECTED",
    NotDeducted = "NOT_DEDUCTED",
}

export const chargebackStatusList = [
    {
        value: ChargebackStatus.Pending,
        label: "Pending",
    },
    {
        value: ChargebackStatus.InProgress,
        label: "In progress",
    },
    {
        value: ChargebackStatus.Refunded,
        label: "Refunded",
    },
    {
        value: ChargebackStatus.Rejected,
        label: "Rejected",
    },
    {
        value: ChargebackStatus.NotDeducted,
        label: "Not deducted",
    },
];

